import React from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import DescriptionIcon from '@mui/icons-material/Description';
import CodeIcon from '@mui/icons-material/Code';
import DirectionsIcon from '@mui/icons-material/Directions';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';

export const generateCitationUrl = (citation) => {
  if (!citation || !citation.source_type) return null;

  switch (citation.source_type) {
    case 'transport':
      return citation.transport_id ? `/transport/${citation.transport_id}` : null;
    case 'planning': {
      const ids = citation.planning_ids;
      return Array.isArray(ids) && ids.length > 0 ? `/planning/${ids[0]}` : null;
    }
    case 'route_map':
      return `/vehicles/map`;
    case 'transport_historie':
    case 'transport_archive':
      return citation.transport_id ? `/planning/transport/${citation.transport_id}` : null;
    case 'page_help':
    case 'doc':
    case 'code':
    case 'features':
    default:
      return null;
  }
};

export const getCitationIcon = (sourceType) => {
  switch (sourceType) {
    case 'page_help':
      return <HelpOutlineIcon fontSize="small" />;
    case 'doc':
      return <DescriptionIcon fontSize="small" />;
    case 'code':
      return <CodeIcon fontSize="small" />;
    case 'route_map':
      return <DirectionsIcon fontSize="small" />;
    case 'transport':
    case 'transport_historie':
    case 'transport_archive':
      return <LocalShippingIcon fontSize="small" />;
    case 'features':
    case 'planning':
      return <FeaturedPlayListIcon fontSize="small" />;
    default:
      return null;
  }
};

